import type React from 'react';

import { Banner } from './component/Banner';

type AppDownloadBottomBannerV2Props = {
	sourceLocation: string;
	ownPetition: boolean;
	iOSBannerEnabled: boolean;
	androidBannerEnabled: boolean;
	desktopBannerEnabled: boolean;
};

export const AppDownloadBottomBannerV2: React.FC<AppDownloadBottomBannerV2Props> = ({
	sourceLocation,
	ownPetition,
	iOSBannerEnabled,
	androidBannerEnabled,
	desktopBannerEnabled,
}) => {
	if (!ownPetition) return null;

	return (
		<Banner
			sourceLocation={sourceLocation}
			iOSBannerEnabled={iOSBannerEnabled}
			androidBannerEnabled={androidBannerEnabled}
			desktopBannerEnabled={desktopBannerEnabled}
		/>
	);
};
